<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <Title :title-params="primary.title" is-title :class="$style.title" />
      <ul :class="$style.categoryList">
        <li
          v-for="(category, categoryIndex) in categories"
          :key="categoryIndex"
          :class="$style.category"
        >
          <a :href="`#${categoryUid(category.categoryId)}`">
            {{ categoryName(category.categoryId) }}
          </a>
        </li>
      </ul>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import { getFormatedLink } from '~/mixins/getFormatedLink'
export default {
  name: 'Categories',

  components: {
    Title,
  },

  mixins: [getFormatedLink],

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },

  methods: {
    formatedLink(categoryName) {
      return this.getFormatedLink({
        link_type: 'Document',
        uid: categoryName,
        type: 'advices_category_page',
        lang: this.$i18n.localeProperties.prismicIso.toLowerCase(),
      })
    },

    categoryName(categoryId) {
      return this.$store.state.adviceCategoryData[categoryId].category_name
    },

    categoryUid(categoryId) {
      return this.$store.state.adviceCategoryData[categoryId].uid
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 80px;

  background-color: $bluko-800;
}

.inner {
  padding: 48px 30px;
  @include below(small) {
    padding: 45px 45px;
  }
}

.title {
  color: white;
  font-weight: 200;
  font-size: 40px;
  line-height: 45px;
  text-align: center;
}

.categoryList {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 40px;

  li {
    margin: 4px;
  }

  @include above(small) {
    li {
      margin: 12px;
    }
  }
}

.category a {
  @include typo-headline;
  display: block;
  padding: 8px 20px;
  border-radius: 24px;

  color: white;
  font-weight: 400;
  text-decoration: none;

  background-color: $bluko-700;

  transition-duration: 0.3s;

  transition-property: color, background-color;

  &:hover {
    font-weight: 400;

    background-color: $bluko-600;
  }
}
</style>
